import { render } from "./StackedColumnChart.vue?vue&type=template&id=3b798b04"
import script from "./StackedColumnChart.vue?vue&type=script&lang=js"
export * from "./StackedColumnChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__